import { render } from "./denied.vue?vue&type=template&id=5f8e478e"
import script from "./denied.vue?vue&type=script&lang=js"
export * from "./denied.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__